import { get } from "lodash-es";
import { MESApiService, getMomentTz, spParameter } from "../../../../services";
import { Entry } from "../../entry/models/Entry";

const moment = getMomentTz();

export const getEntriesReport = async (
	params: {
		startShiftId?: number | null;
		endShiftId?: number | null;
		assetId?: number | null;
		searchText?: string | null;
	},
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "StartShiftId", value: params.startShiftId as number },
		{ name: "EndShiftId", value: params.endShiftId as number },
	];

	if (params.assetId != null) {
		parameters.push({ name: "AssetId", value: params.assetId });
	}

	if (params.searchText) {
		parameters.push({ name: "SearchText", value: params.searchText });
	}

	const resp = await apiService.callV2("[LB].[GetEntries]", parameters);

	if (resp.ok) {
		let rows = get(resp, "data.tables[0].rows", []) as Entry[];

		rows = rows.map((entry: Entry) => ({
			...entry,
			CreateTimestamp: entry.CreateTimestamp
				? moment.utc(entry["CreateTimestamp"]).toDate()
				: null,
			UpdateTimestamp: entry.UpdateTimestamp
				? moment.utc(entry["UpdateTimestamp"]).toDate()
				: null,
		}));

		return rows;
	} else {
		throw new Error(resp.message || "Error fetching entries");
	}
};
